import { render } from "./PersonalData.vue?vue&type=template&id=5ad76d32&scoped=true&ts=true"
import script from "./PersonalData.vue?vue&type=script&lang=ts"
export * from "./PersonalData.vue?vue&type=script&lang=ts"

import "./PersonalData.vue?vue&type=style&index=0&id=5ad76d32&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ad76d32"]])

export default __exports__